import { render, staticRenderFns } from "./UserBetgameSettings.vue?vue&type=template&id=73e18782&scoped=true"
import script from "./UserBetgameSettings.vue?vue&type=script&lang=js"
export * from "./UserBetgameSettings.vue?vue&type=script&lang=js"
import style0 from "./UserBetgameSettings.vue?vue&type=style&index=0&id=73e18782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e18782",
  null
  
)

export default component.exports